import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=4955dae6&scoped=true&"
import script from "./ProgramsList.vue?vue&type=script&lang=js&"
export * from "./ProgramsList.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsList.vue?vue&type=style&index=0&id=4955dae6&scoped=true&lang=css&"
import style1 from "./ProgramsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955dae6",
  null
  
)

export default component.exports